<template>
  <div class="simple-editor">    
    <div class="toolbar" v-show="showToolbar||true">
      <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('bold')}">
        <font-awesome-icon icon="bold" fixed-width />
      </a>
      <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('italic')}">
        <font-awesome-icon icon="italic" fixed-width />
      </a>
      <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('underline')}">
        <font-awesome-icon icon="underline" fixed-width />
      </a>
      <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('strikeThrough')}">
        <font-awesome-icon icon="strikethrough" fixed-width />
      </a>
       <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('justifyLeft')}">
        <font-awesome-icon icon="align-left" fixed-width />
      </a>
      <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('justifyCenter')}">
        <font-awesome-icon icon="align-center" fixed-width />
      </a>
       <a href="javascript:void(0)" @mousedown.stop.prevent="(evt) => {cmd('justifyRight')}">
        <font-awesome-icon icon="align-right" fixed-width />
      </a>
    </div>
    <div class="editor" @paste="pasteEvent"  ref="editor" @focus="() => showToolbar = true" @blur="() => showToolbar = false" contenteditable @input="updateContent" v-html="content"></div>
    <input type="hidden" :name="name" v-model="RealContent"  />
  </div>
</template>
<script>

  export default {
    data() {
      return {
         content: this.value,
         realContent: this.value,
         showToolbar: false,
      }
    },
    props: ['value', 'name'],
    computed: {
      RealContent: {
        get() {
          return this.realContent;
        },
        set(value) {
          this.realContent = value;
          this.content = value;
        }
      }
    },
    methods: {
      pasteEvent(e) {
        // cancel paste
        e.preventDefault();

        // get text representation of clipboard
        var text = (e.originalEvent || e).clipboardData.getData('text/plain');

        // insert text manually
        document.execCommand("insertHTML", false, text);
      },
      updateContent() {
        let content = this.$refs.editor.innerHTML;
        this.realContent = content;
        this.$emit('input', content);
      },
      cmd(cmd, value = null) {        
        document.execCommand(cmd, false, value);
        //return false;
      }
    },
    mounted() {
      document.execCommand('')
    }
  };

</script>
<style >
  .toolbar a {
      display: inline-block;
      padding: 8px;
      background: #eee;
      border: 1px solid white;
      cursor: pointer;
      color: black;
      text-decoration: none;
      box-sizing: border-box;
  }
  .editor {
    display: inline-block;
    width: 100%;
    padding: 8px;
    border: 1px solid #eee;
    margin-bottom: 8px;
    box-sizing: border-box;
  }
</style>